import * as _ from 'lodash';

import { ActionType, ActionTypes, State } from './types';

const FIRST_PAGE = 1;
const INITIAL_TOTAL_ITEMS = 0;

const initialState = {
  isLoading: false,
  error: '',
  items: [],
  totalItems: INITIAL_TOTAL_ITEMS,
  page: FIRST_PAGE,
  details: {
    isLoading: false,
    error: '',
    data: [],
  },
  favorites: [],
  filters: {
    gp: false,
    credits: [0, 450],
    cats: [],
    sort: undefined,
    text: undefined,
  },
  selected: undefined,
  fetchTime: undefined,
};

const promotionsReducer = (state: State = initialState, action: ActionType): State => {
  const actualFavs = state?.favorites ? [...state.favorites] : [];
  switch (action.type) {
    case ActionTypes.FETCH_INVITATIONS_START:
      return {
        ...state,
        isLoading: true,
        fetchTime: undefined,
      };
    case ActionTypes.FETCH_INVITATIONS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        items: _.uniqBy([...state.items, ...action.payload], 'id'),
        totalItems: action.totalItems,
        fetchTime: Date.now(),
      };
    case ActionTypes.ADD_SELECTED_INVITATION:
      return {
        ...state,
        items: _.uniqBy([...state.items, action.payload], 'id'),
      };
    case ActionTypes.FETCH_INVITATIONS_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
        fetchTime: undefined,
      };
    case ActionTypes.FETCH_INVITATION_DETAIL_START:
      return {
        ...state,
        details: {
          ...state.details,
          isLoading: true,
        },
      };
    case ActionTypes.FETCH_INVITATION_DETAIL_SUCCESS:
      return {
        ...state,
        details: {
          ...state.details,
          isLoading: false,
          data: action.payload,
        },
      };
    case ActionTypes.FETCH_INVITATION_DETAIL_FAIL:
      return {
        ...state,
        details: {
          ...state.details,
          isLoading: false,
          error: action.payload,
        },
      };
    case ActionTypes.CHANGE_PAGE:
      return {
        ...state,
        page: action.payload,
      };
    case ActionTypes.SET_SELECTED_INVITATION:
      return {
        ...state,
        selected: action.payload,
      };
    case ActionTypes.CLEAR_INVITATIONS:
      return {
        ...state,
        items: [],
        page: FIRST_PAGE,
        totalItems: INITIAL_TOTAL_ITEMS,
        details: {
          isLoading: false,
          error: '',
          data: [],
        },
        fetchTime: undefined,
      };
    case ActionTypes.UPDATE_FILTERS:
      return {
        ...state,
        filters: action.payload,
      };
    case ActionTypes.ADD_FAVORITE:
      return {
        ...state,
        favorites: [...actualFavs, action.payload],
      };
    case ActionTypes.REMOVE_FAVORITE:
      return {
        ...state,
        favorites: actualFavs.filter((item) => item.targetId !== action.payload),
      };
    case ActionTypes.SET_FAVORITES:
      return {
        ...state,
        favorites: action.payload,
      };
    default:
      return state;
  }
};

export default promotionsReducer;
